import { DELETE, GET, POST, PATCH } from "../API";

export const getGlossaryTermsAPICall = (
    projectId,
    page,
    perPage,
    search,
    onSuccess,
    onError
) => {
    const params = new URLSearchParams();
    if (page) params.append('page', page);
    if (perPage) params.append('per_page', perPage);
    if (search) params.append('search', search);

    const url = process.env.REACT_APP_API_PATH + `/public_api/projects/${projectId}/glossary_terms${params.toString() ? '?' + params.toString() : ''}`;

    GET(
        url,
        onSuccess,
        onError
    );
};

export const createGlossaryTermAPICall = (
    projectId,
    data,
    onSuccess,
    onError
) => {
    POST(
        process.env.REACT_APP_API_PATH + `/public_api/projects/${projectId}/glossary_terms`,
        data,
        onSuccess,
        onError
    );
};

export const updateGlossaryTermAPICall = (
    projectId,
    termId,
    data,
    onSuccess,
    onError
) => {
    PATCH(
        process.env.REACT_APP_API_PATH + `/public_api/projects/${projectId}/glossary_terms/${termId}`,
        data,
        onSuccess,
        onError
    );
};

export const deleteGlossaryTermAPICall = (
    projectId,
    termId,
    onSuccess,
    onError
) => {
    DELETE(
        process.env.REACT_APP_API_PATH + `/public_api/projects/${projectId}/glossary_terms/${termId}`,
        onSuccess,
        onError
    );
};
